var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$route.meta.layout,{tag:"component"},[_c('p',[_vm._v("This is an About page")]),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v(" Go Home ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }